import React, {Component} from "react";
import {TouchableOpacity, View, Text, Image, I18nManager, Platform, ScrollView} from "react-native";
import Colors from "../../tools/Colors";


import {moderateScale} from "../../tools/Scaling";
import HMModal from "../modal/HMModal";

import HMIcon from "../HMIcon";
import HMVideo from "../video/HMVideo";

export default class HMLightbox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visibleModal: false,
        }
    }

    hiddenModal() {
        this.setState({visibleModal: false})
    }

    render() {
        const {source_image,pathVideo, uri, PlaceHolder, text, textStyle, textType, style, type, borderRadius, height, NoShowIconOnpress, onPress, title, title2, image, renderCustom} = this.props;
        return (
            <TouchableOpacity
                onPress={() => {
                    this.setState({visibleModal: !this.state.visibleModal})
                }}
                style={{
                    width: "100%",
                    height: "100%",
                    resizeMode: 'contain',
                    backgroundColor: Colors.black
                }}
            >
                {
                    renderCustom ?
                        renderCustom("small")
                        :
                        (
                            pathVideo ?
                                <Image
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        resizeMode: 'contain',
                                        backgroundColor: Colors.black
                                    }}
                                    //source={{uri: 'https://poponik.com/wp-content/uploads/2018/09/Black-Rose-00.jpg'}}
                                    source={source_image}
                                />
                                :
                                <Image
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        resizeMode: 'contain',
                                        backgroundColor: Colors.black
                                    }}
                                    //source={{uri: 'https://poponik.com/wp-content/uploads/2018/09/Black-Rose-00.jpg'}}
                                    source={{uri: uri}}
                                />
                        )
                }
                {
                    this.renderModal(renderCustom, pathVideo)
                }
            </TouchableOpacity>
        );
    }

    renderModal(renderCustom, pathVideo) {
        return (
            <HMModal
                isVisible={this.state.visibleModal}
                //visible={this.state.visibleModal}
                backdropColor={Colors.gray}
                backdropOpacity={0.8}
                animationIn="zoomInDown"
                animationOut="zoomOutUp"
                animationInTiming={600}
                animationOutTiming={600}
                backdropTransitionInTiming={600}
                backdropTransitionOutTiming={600}
                //style={{height: '60%'}}
                onBackdropPress={() => this.hiddenModal()}
                onBackButtonPress={() => this.hiddenModal()}

                animationType="slide"
                // transparent={true}
            >

                <View style={[{width: "100%", height: "100%",}]}>
                    {
                        renderCustom ?
                            renderCustom("large")
                            :
                            (
                                pathVideo ?
                                    <HMVideo
                                        //   title={title}
                                        //    navigation={this.props.navigation}
                                        path={pathVideo}
                                        //index={item.index}
                                        //  indexSelect={this.state.slider1ActiveSlide}
                                        //url={"http://techslides.com/demos/sample-videos/small.mp4"}
                                    />
                                    :
                                    <Image
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            resizeMode: 'contain',
                                            backgroundColor: Colors.black
                                        }}
                                        //source={{uri: 'https://poponik.com/wp-content/uploads/2018/09/Black-Rose-00.jpg'}}
                                        source={{uri: this.props.uri}}
                                    />
                            )
                    }

                    <TouchableOpacity
                        style={{position: 'absolute', top: 0, left: 0, padding: moderateScale(8)}}
                        onPress={() => {
                            this.hiddenModal()
                        }}
                    >
                        <HMIcon name={"ios-close"} style={{color: Colors.white, fontSize: moderateScale(28)}}/>
                    </TouchableOpacity>
                </View>
            </HMModal>
        );
    }
}
